import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

const Breakdown = ({ globalData }) => {
    return (
        <Container>
            <Row>
                <Col md={12} className="mt-2">
                    <div className="content-main-div">
                        <h1 className="content-heading">
                            Swift Response and Expert Solutions for Vehicle Breakdowns in UAE
                        </h1>
                        <p className="content-paragraph">Breakdowns can be a nightmare, and they always seem to happen at the worst possible time. Whether you're on your way to work, school, or an important meeting, a breakdown can leave you stranded and stressed. That's where Open Bonnet comes in. We offer reliable and efficient breakdown services to ensure that you're never left stranded.
                        </p>

                        <h4 className="content-sub-heading">Why Choose Breakdown?
                        </h4>
                        <p className="content-paragraph">At Open Bonnet, we understand that breakdowns can be a stressful experience. That's why we offer a range of services to get you back on the road as quickly and safely as possible. Our team of experienced professionals is equipped to handle a variety of breakdown situations, from flat tires and lockouts to battery boosts and refueling.
                        </p>

                        <h4 className="content-sub-heading">Why Choose Open Bonnet?
                        </h4>
                        <p className="content-paragraph">When it comes to breakdowns, you need a company you can trust. At Open Bonnet, we are committed to providing the highest level of service to our customers. We pride ourselves on our reliability, efficiency, and professionalism. Our team of experts is available 24/7 to assist you in any breakdown situation.
                        </p>

                        <ul className="content-second-list">
                            <li className="list-li">
                                <span className="list-li-span">Battery Boost :</span>
                                If your car won't start, the most common cause is a dead battery. We can help by providing a battery boost service. Our experts will jump-start your vehicle, so you can get back on the road in no time.
                            </li>
                            <li className="list-li">
                                <span className="list-li-span">Flat Tyre :</span>
                                Flat tires can happen at any time, and they can be a real inconvenience. Our team can help by changing your flat tire or providing a tire repair service if possible. We will get you back on the road quickly and safely.
                            </li>
                            <li className="list-li">
                                <span className="list-li-span">Flat Bed Recovery :</span>
                                If your vehicle cannot be repaired on the spot, we offer flatbed recovery services to transport your vehicle to a service center or a location of your choice.
                            </li>
                            <li className="list-li">
                                <span className="list-li-span">Lockout :</span>
                                Lockouts can be frustrating, but they can also be dangerous if you're stranded in an unsafe location. Our team can help by unlocking your vehicle quickly and safely, so you can get back on the road. In addition to our breakdown services, We also offer comprehensive <a className='paragraph-link' href={`/services/${globalData.locationData?.data?.EmirateAreaSlug ||
                                    "dubai"
                                    }/inspection`}>Vehicle  inspections</a>. Whether you're buying a used car or want to ensure the safety and reliability of your current vehicle, our inspection services can provide you with a detailed assessment of its condition.
                            </li>
                            <li className="list-li">
                                <span className="list-li-span">Refueling :</span>
                                Running out of gas can be a major inconvenience, but it doesn't have to be a disaster. Our team can bring you enough fuel to get you to the nearest gas station, so you can fill up and continue your journey.
                            </li>
                        </ul>

                        <p className="content-paragraph">At Open Bonnet, we understand the importance of reliable breakdown services. That's why we offer a range of services to get you back on the road as quickly and safely as possible. With our commitment to quality, convenience, and trust, you can count on us to be there for you in any breakdown situation.
                        </p>

                    </div>

                </Col>
            </Row>
        </Container >
    )
}

export default Breakdown
